import { render, staticRenderFns } from "./PaymentInvoiceItem.vue?vue&type=template&id=200b4bfe&scoped=true"
import script from "./PaymentInvoiceItem.vue?vue&type=script&lang=js"
export * from "./PaymentInvoiceItem.vue?vue&type=script&lang=js"
import style0 from "./PaymentInvoiceItem.vue?vue&type=style&index=0&id=200b4bfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200b4bfe",
  null
  
)

export default component.exports